import { Button } from '@wartek-id/button-v1'

import PanelPerilakuKerja from 'app/KinerjaPage/components/PanelPerilakuKerja'
import StickyFooter from 'app/KinerjaPage/components/StickyFooter'
import useContentContext from 'app/KinerjaPage/hooks/useContentContext'

import type { Kinerja } from 'types/kinerja'

interface TabPerilakuKerjaProps {
  skp: Kinerja
  onClickNext?: () => void
}

const TabPerilakuKerjaWaitingApproval = ({
  skp,
  onClickNext = () => {},
}: TabPerilakuKerjaProps) => {
  const { contentPerilakuKerja } = useContentContext()

  const getAspekById = (id: number) => {
    return contentPerilakuKerja.aspek.find((aspek) => aspek.id === id)
  }

  return (
    <>
      <div className="p-9">
        <div className="flex flex-col gap-9">
          {skp.prilakuKerja.map((perilakuKerja) => {
            const aspek = getAspekById(perilakuKerja.aspekId)

            return (
              <PanelPerilakuKerja
                key={`PanelPerilakuKerja-${aspek.id}`}
                data-testid={`PanelPerilakuKerja-${aspek.id}`}
                title={aspek?.value}
                indikatorPerilaku={
                  aspek?.indikator.find(
                    (indikator) => indikator.id === perilakuKerja.indikatorId
                  )?.value
                }
                perwujudanPerilaku={
                  aspek?.indikator
                    .find(
                      (indikator) => indikator.id === perilakuKerja.indikatorId
                    )
                    ?.ekspektasi.find(
                      (ekspektasi) =>
                        ekspektasi.id === perilakuKerja.ekspektasiId
                    )?.value
                }
              />
            )
          })}
        </div>
      </div>

      <StickyFooter>
        <Button
          size="lg"
          onClick={() => onClickNext()}
          type="button"
          data-testid="btn-back-to-home"
        >
          Kembali ke Beranda
        </Button>
      </StickyFooter>
    </>
  )
}

export default TabPerilakuKerjaWaitingApproval
